// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"38":"8b4a73c4","136":"b4ef3216"}[chunkId] + ".js";
};